import { LOCALIZED_CMS_DATA } from './cmsData';

// CMS Utility for Danshaker
const API_BASE_URL = 'https://api.dev.auxo.dk';

// Fallback data (scraped 1:1)
export const FALLBACK_DATA = {
  testimonials: [
    {
      id: "nis-1",
      name: "Nis Friis Virenfeldt",
      company: "DK • 4 anmeldelser • 31. jan. 2026",
      text: "<p><strong>Høj kvalitet og service i særklasse!</strong></p><p>Vi har nu haft vores Danshaker i et år, kunne vi gøre noget anderledes skulle vi have købt den længe før!</p><p>Den bruges dagligt til 10 heste/ponyer og er en stor besparelse i spånerne, dette giver også et væsentlig mindre tømnings interval af møg containeren!</p><p>Vi har oplevet super god service fra Rasmus, han er en teknik-nørd der ofte tager kontakt til os for at kontrollere kundetilfredshed og er altid ved at udvikle og lave forbedringer på udstyret så alle føler sig som vindere.</p><p>Største anbefaling herfra🙏🐴</p>",
      image: []
    },
    {
      id: "sanne-1",
      name: "Sanne",
      company: "DK • 8 anmeldelser • 2. feb. 2026",
      text: "<p><strong>Fantastisk oplevelse hos Danshaker</strong></p><p>Jeg har haft en virkelig god oplevelse hos Danshaker, hvor Rasmus leverede en personlig og imødekommende service fra start til slut. Man føler sig virkelig godt vejledt og taget hånd om.</p><p>Produktet er af høj kvalitet, og vores heste trives rigtig godt med det. Den luftige bund i boksen giver en mærkbar forbedring af komforten – underlaget er både mere behageligt og mere fleksibelt for hesten.</p><p>Derudover har jeg oplevet en besparelse på forbruget af træpiller i bunden, samt den tid vi bruger på det daglige staldarbejde.</p><p>Alt i alt kan jeg varmt anbefale Danshaker – takket være Rasmus’ gode service, den høje kvalitet og den øgede komfort for hesten.</p>",
      image: []
    },
    {
      id: "1",
      name: "Team Madsbjerg",
      company: "Team Madsbjerg",
      text: "<p>Rasmus fra Danshaker står 100% bag, hvad han siger og lover – dette er lige så vigtigt, som det produkt han sælger.</p><p>Vi glæder os hver dag til at skulle i stalden for at bruge maskinen.</p><p>Maskinen er mega nem at bruge og giver samtidig en lækker luftig og blød bund.</p>",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/869578f4-4087-49ae-9256-01442dfeaff9.jpg"]
    },
    {
      id: "2",
      name: "Dan Jeppesen",
      company: "Molger Rideklub",
      text: "<p>Maskinen har virkelig gjort en kæmpe forskel i vores stald – både for personalet og medlemmerne.</p><p>Det er blevet meget nemmere at holde bunden, og vi kan allerede mærke hvor meget lettere hverdagen er blevet.</p><p>Hestene står meget blødere og det kan vi virkelig mærke på dem – det betyder meget for os!</p><p>Tak for en super løsning – vi er virkelig glade for den!</p><p>De bedste anbefalinger herfra.</p>",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ee3409b4-4a03-4472-bb2f-a5861cc8d979.jpg"]
    },
    {
      id: "3",
      name: "M-Horses",
      company: "M-Horses",
      text: "<p>Vi er super glade for maskinen, da den er nem at bruge, komme rundt med og strøbesparende.</p><p>Vi bruger heller ikke så lang tid på sorteringen som før.</p>",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/dca27bba-1daf-44d2-87c2-ae31a6dff125.jpg"]
    },
    {
      id: "4",
      name: "Michelle Lauridsen",
      company: "Stald Bøgen, Esbjerg",
      text: "<p>Vi har flere heste i vores stald, der sviner ekstremt meget.</p><p>Tidligere tog en sortering i disse bokse 30-40 minutter pr. boks – efter vi har fået Danshakeren er den tid kommet under 10 minutter pr. boks.</p><p>Vores staldpige sorterer dagligt vores 10 bokse.</p><p>Normalt var her helt udkørt efter 4-5 bokse, men efter at vi har fået Danshakeren, klarer hun alle 10 bokse uden problemer og har også overskud til andre forefaldende opgaver i stalden.</p><p>Vi kan varmt anbefale Danshakeren og giver den 10/10 stjerner</p>",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/500774ed-a863-4e49-9e78-26eeb7273db5.jpg"]
    },
    {
      id: "5",
      name: "Odgaard Horses",
      company: "Odgaard Horses",
      text: "<p>Vi have brugt maskinen dagligt siden årsskiftet og er specielt begejstrede for at slippe for de belastende og repetitive bevægelser i sorteringsarbejdet.</p><p>Det er nemt at skovle op i maskinen og vi ser at alle i stalden hurtigt finder en rytme med maskinen.</p><p>Vi er så småt begyndt at se effektivitetsforbedringer med mindre mødding samt hurtigere sortering, hvilket vi forventer er en tendens som vil fortsætte og levere besparelser fremadrettet.</p><p>Alt i alt er vi glade og synes det virker som en lovende investering.</p>",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/ce39733b-86c6-4c8a-83d0-06b042411306.jpg"]
    }
  ],
  nyheder: [
    {
      id: "n1",
      title: "Gør din Danshaker personlig",
      date: "19. januar 2026",
      content: "<p>Nu kan du vælge at gøre din nye Danshaker helt personlig, ved at vælge præcis den farve (RAL) som du synes bedst om.</p><p>Vi tilbyder også at du kan få glimmer i farven mod et mindre tillæg.</p><p>Alle fremtidige modeller får nu helt sorte forhjul i stedet for gule.</p>",
      slug: "goer-din-danshaker-personlig"
    },
    {
      id: "n2",
      title: "Privatfinansiering",
      date: "19. januar 2026",
      content: "<p>Nu kan du få privatfinansieret din nye Danshaker fra blot kr. 1563,-/md. inkl. moms</p><p>Vi har netop indgået et samarbejde med AnyDay, som sikrer, at vi kan tilbyde vores kunder de mest fleksible betalingsløsninger.</p><p>Med AnyDay kan du dele det fulde beløb op i mindre afdrag i helt op til 24 mdr.</p><p>Kontakt os allerede i dag og vi hjælper dig godt på vej.</p>",
      slug: "privatfinansiering"
    }
  ],
  faq: [
    {
      question: "Bruger Danshakeren strøm fra ledning?",
      answer: "<p>Nej – du slipper helt for ledninger. Danshakeren kører på et kraftigt genopladeligt batteri, så du har fuld frihed til at muge ud, hvor og hvornår du vil.</p>"
    },
    {
      question: "Hvor mange bokse kan jeg nå på én opladning?",
      answer: "<p>På en fuld opladning kan du klare helt op til 86 bokse af ca. 10 minutters varighed. Det giver dig masser af kapacitet – selv i store stalde.</p>"
    },
    {
      question: "Hvor lang tid tager det at oplade Danshakeren?",
      answer: "<p>Fra 10 % til 100 % tager det typisk 5–6 timer. Sæt den til om aftenen – så er den klar til en ny arbejdsdag næste morgen.</p>"
    },
    {
      question: "Hvor meget tid sparer jeg ved at bruge Danshakeren?",
      answer: "<p>Flere af vores kunder har halveret deres sorteringstid – nogle sparer helt op til 75 %. Så kan du bruge mere tid på dine heste og mindre tid på det hårde sorteringsarbejde.</p>"
    },
    {
      question: "Hvor meget strøelse kan jeg spare?",
      answer: "<p>Vores kunder oplever ofte helt op til 50 % mindre forbrug af strøelse – og samtidig langt mindre arbejde med håndteringen af møddingen.</p>"
    },
    {
      question: "Hvornår er Danshakeren typisk tjent hjem?",
      answer: "<p>Det er individuelt og afhænger af many faktorer.</p><p>Men i gennemsnit sparer vores kunder 50% på indkøb af strøelse samt tømning af mødding.</p><p>For at opnå den størst mulige besparelse, anbefaler vi, at du bruger maskinen hver dag, samt bruger en fin strøelse som fx smuld.</p>"
    },
    {
      question: "Hvilke typer strøelse virker Danshakeren med?",
      answer: "<p>Den er testet på alle kendte strøelsestyper. Jo finere materialet er, jo mere kan du genbruge – og jo større bliver din besparelse.</p>"
    },
    {
      question: "Er der strøelse, som ikke egner sig til Danshakeren?",
      answer: "<p>Ja, vi fraråder brug i traditionelle halmbokse og til grove spåner, da resultatet ikke bliver optimalt.</p>"
    },
    {
      question: "Kan jeg justere hastigheden på min Danshaker?",
      answer: "<p>Ja – hastigheden kan nemt justeres via din mobil, så den passer til dit tempo.</p>"
    },
    {
      question: "Er Danshakeren svær at rengøre efter brug?",
      answer: "<p>Nej – rengøringen tager kun ca. ét minut i vandspiltorvet. Hurtigt, nemt og klar til næste sortering.</p>"
    },
    {
      question: "Kan jeg eftermontere ekstraudstyr på min Danshaker?",
      answer: "<p>Ja, hvis du har en Danshaker 2.0 (den blå model). Alt tilbehør kan eftermonteres, så du altid kan tilpasse maskinen til dine behov.</p>"
    },
    {
      question: "Jeg har en Danshaker med høj ramme – kan den ændres til lav ramme?",
      answer: "<p>Ja, den lave ramme kan tilkøbes og eftermonteres nemt, hurtigt og enkelt.</p>"
    },
    {
      question: "Kan man leje en Danshaker?",
      answer: "<p>Ja, du kan nu leje en Danshaker i en måned og teste den i den egen stald før du beslutter dig – ganske uforpligtende.</p>"
    },
    {
      question: "Sælger I jeres udlejningsmaskiner?",
      answer: "<p>Nej, vores udlejningsmaskiner er kun til leje – men du kan altid bestille en ny maskine og være sikker på fuld garanti og topkvalitet.</p>"
    },
    {
      question: "Hvor lang er leveringstiden?",
      answer: "<p>Vi bestræber os på at levere din Danshaker inden for seks uger fra bestilling. Så er du hurtigt i gang med at spare både tid og penge.</p>"
    }
  ],
  tilbehoer: [
    {
      name: "Specialfarver",
      description: "Kan leveres i alle farver",
      price: "Kr. 995.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/a91119ee-cb50-4bb0-8636-9ff6a6aa87e2.jpg"]
    },
    {
      name: "Trillebørsophæng",
      description: "Ophæng til trillebør (Kommer til forår 2025)",
      price: "Kr. 995.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/e78bab06-df3e-49dd-b2cd-e5a4891479a9.jpg"]
    },
    {
      name: "Sideudkast",
      description: "Kan justeres manuelt, højre eller venstre.",
      price: "Kr. 4.995.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/80ade798-7838-4838-ba9d-88d0e973e725.jpg"]
    },
    {
      name: "Drikkedunkholder",
      description: "Med magnet.",
      price: "Kr. 395.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"]
    },
    {
      name: "Redskabsholder",
      description: "20-30 mm eller 25-35 mm. Pr. sæt",
      price: "Kr. 595.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg"]
    },
    {
      name: "Gummibremse",
      description: "Til rensning af ridebanebund.",
      price: "Kr. 995.-",
      image: ["https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg"]
    }
  ],
  galleri: [
    {
      title: "Danshaker Detaljer",
      slug: "danshaker-detaljer",
      images: [
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/danshaker-3-farver_e98ea2d5.png",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/88965ac8-a30d-41c2-b3d4-878dd054d8f1.jpg",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/de8c8522-492e-4e3d-b905-652dfdcf1c5e.jpg",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/735ab98a-19ad-4a44-8706-12f21749ddce.jpg",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/8dbd0056-687d-4231-9ce4-f8f186646ff9.jpg",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/c4a731ab-6721-435d-8de5-d6368af70f19.jpg",
        "https://assets.auxodev.dk/assets/e0cd175c-a113-44c2-9ab9-d86f3c298af2/161dd1a5-3a30-4270-96d6-4877c10479a3.jpg"
      ]
    }
  ]
};

// Helper function to extract localized string
export function getLocalized(field, lang = 'da') {
  if (!field) return '';
  if (typeof field === 'string') return field;
  if (field[lang] !== undefined) return field[lang];
  // Fallback to first available language
  const keys = Object.keys(field);
  if (keys.length > 0) return field[keys[0]];
  return '';
}

// Fetch list of items from collection
export async function fetchCollection(collectionName, lang = 'da') {
  if (lang !== 'da' && LOCALIZED_CMS_DATA[lang]?.[collectionName]) {
    return LOCALIZED_CMS_DATA[lang][collectionName];
  }

  try {
    const res = await fetch(`${API_BASE_URL}/public/content/${collectionName}`);
    if (!res.ok) throw new Error(`Failed to fetch ${collectionName}`);
    const data = await res.json();
    
    if (Array.isArray(data) && data.length > 0) {
      // Map the data to a cleaner format
      const items = data.map(item => {
        const cleaned = { id: item.id };
        // Extract fields
        Object.keys(item).forEach(key => {
          if (['id', 'projectId', 'collectionName', 'updatedAt', 'PK', 'SK', '__edb_e__', '__edb_v__'].includes(key)) return;
          
          // If it's a localized field, extract the 'da' value
          if (item[key] && typeof item[key] === 'object' && !Array.isArray(item[key])) {
            cleaned[key] = getLocalized(item[key], 'da');
          } else {
            cleaned[key] = item[key];
          }
        });
        
        // Handle system slug
        if (item.slug) {
          cleaned.slug = getLocalized(item.slug, 'da') || cleaned.slug;
        }
        
        return cleaned;
      });

      if (collectionName === 'testimonials') {
        items.sort((a, b) => {
          const nameA = a.name || '';
          const nameB = b.name || '';
          const getPriority = (name) => {
            if (name.includes('Nis Friis Virenfeldt')) return 1;
            if (name.includes('Sanne')) return 2;
            return 99;
          };
          return getPriority(nameA) - getPriority(nameB);
        });
      }

      return items;
    }
    
    return FALLBACK_DATA[collectionName] || [];
  } catch (err) {
    console.warn(`CMS Fetch failed for ${collectionName}, using fallback data:`, err);
    return FALLBACK_DATA[collectionName] || [];
  }
}

// Fetch single item by slug
export async function fetchBySlug(slug, lang = 'da') {
  if (lang !== 'da' && LOCALIZED_CMS_DATA[lang]) {
    for (const col of Object.keys(LOCALIZED_CMS_DATA[lang])) {
      const found = LOCALIZED_CMS_DATA[lang][col].find(x => x.slug === slug);
      if (found) return { ...found, collectionName: col };
    }
  }

  try {
    const res = await fetch(`${API_BASE_URL}/public/by-slug/${lang}/${slug}`);
    if (!res.ok) throw new Error(`Failed to fetch slug ${slug}`);
    const item = await res.json();
    
    if (item) {
      const cleaned = { id: item.id, collectionName: item.collectionName };
      Object.keys(item).forEach(key => {
        if (['id', 'projectId', 'collectionName', 'updatedAt', 'PK', 'SK', '__edb_e__', '__edb_v__'].includes(key)) return;
        
        if (item[key] && typeof item[key] === 'object' && !Array.isArray(item[key])) {
          cleaned[key] = getLocalized(item[key], lang);
        } else {
          cleaned[key] = item[key];
        }
      });
      
      if (item.slug) {
        cleaned.slug = getLocalized(item.slug, lang) || cleaned.slug;
      }
      
      return cleaned;
    }
    
    // Fallback search
    for (const col of Object.keys(FALLBACK_DATA)) {
      const found = FALLBACK_DATA[col].find(x => x.slug === slug);
      if (found) return { ...found, collectionName: col };
    }
    return null;
  } catch (err) {
    console.warn(`CMS Fetch by slug failed for ${slug}, using fallback:`, err);
    for (const col of Object.keys(FALLBACK_DATA)) {
      const found = FALLBACK_DATA[col].find(x => x.slug === slug);
      if (found) return { ...found, collectionName: col };
    }
    return null;
  }
}
